import React from "react";
import Spkapexcharts from "./spk-apexcharts";

const SalesOverviewCard = ({ Overoptions, Overseries }) => (
  <div className="card custom-card">
    <div className="card-header d-flex justify-content-between align-items-center">
      <h5 className="card-title mb-0">Monthly Overview</h5>
      <div className="dropdown">
        <button className="btn btn-sm btn-light text-muted dropdown-toggle" type="button" id="salesOverviewDropdown" data-bs-toggle="dropdown" aria-expanded="false">
          Sort By
        </button>
        <ul className="dropdown-menu" aria-labelledby="salesOverviewDropdown">
          <li><a className="dropdown-item" href="#">This Week</a></li>
          <li><a className="dropdown-item" href="#">Last Week</a></li>
          <li><a className="dropdown-item" href="#">This Month</a></li>
        </ul>
      </div>
    </div>
    <div className="card-body">
      <div id="sales-overview" style={{ width: '100%', height: 315 }}>
        <Spkapexcharts
          chartOptions={Overoptions}
          chartSeries={Overseries}
          type="bar"
          width={"100%"}
          height={315}
        />
      </div>
    </div>
  </div>
);

export default SalesOverviewCard;
